import * as Sentry from "@sentry/react";
import { apiBase, appEnvironment, sentryDsn } from "./environment";

const SENTRY_ENVIRONMENTS = {
	production: "production",
	staging: "staging",
} as const;

type SentryEnvironment = keyof typeof SENTRY_ENVIRONMENTS;

const initializeSentry = () => {
	const environment = appEnvironment as SentryEnvironment;

	const isNotLocalhost = !apiBase.includes("localhost");
	const canInitSentry = SENTRY_ENVIRONMENTS[environment] && isNotLocalhost;

	if (!canInitSentry) return;

	const isProduction = environment === SENTRY_ENVIRONMENTS.production;
	const tracesSampleRate = isProduction ? 0.75 : 1.0;

	Sentry.init({
		dsn: sentryDsn,
		environment,
		integrations: [Sentry.browserTracingIntegration()],
		tracesSampleRate,
		beforeSend: (event) => {
			const ignoredErrors = ["AbortError", "Aborted in beforeRetry"];
			if (
				event.exception?.values?.some((value) => {
					const message = `${value.type ?? ""} ${value.value ?? ""}`;
					return ignoredErrors.some((ignored) => message.includes(ignored));
				})
			) {
				return null;
			}

			const ignoredUrls = [
				"analytics.google.com",
				"googletagmanager.com",
				"outbrain.com",
				"taboola.com",
			];
			if (
				ignoredUrls.some(
					(url) =>
						event.breadcrumbs?.some((breadcrumb) => {
							const data = breadcrumb.data;
							if (!data || !data.url || typeof data.url !== "string") return false;
							const breadcrumbUrl = data.url;
							if (!breadcrumbUrl) return false;
							return breadcrumbUrl.includes(url);
						}),
				)
			) {
				return null;
			}

			return event;
		},
	});
};

initializeSentry();
